import { createActionGroup, emptyProps, props } from '@ngrx/store';

/**
 * Opens/closes the full-screen image overlay viewer.
 *
 * Mirrors {@link DocumentViewerActions}: the overlay is the image sibling of
 * the PDF document viewer, opened from the same chip-click seam. An image chip
 * routes here; a document chip still routes to the PDF viewer.
 */
export const ImageOverlayActions = createActionGroup({
  source: 'Image Overlay',
  events: {
    // Post-send: an image chip in the message thread.
    'Open Image From Chat Message': props<{
      documentUuid: string;
      filename: string;
    }>(),
    // Pre-send: a staged image chip in the composer. The smart component
    // resolves the URL the same way for every source — cached preview blob
    // (ChatImagePreviewStore) first, presigned fallback — so no chip-type hint
    // is needed here.
    'Open Image From Composer': props<{
      uuid: string;
      filename: string;
    }>(),
    'Close Image Overlay': emptyProps(),
  },
});
